import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Separator = function Separator(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.separator, 'data-hook': 'menu-navigation-separator' },
    children
  );
};

Separator.propTypes = {
  children: PropTypes.node
};

export default Separator;
//# sourceMappingURL=Separator.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/Separator.js